import { render } from "./BulletListWithOneCheckmarkIcon.vue?vue&type=template&id=a6a274be"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__